module.exports = __webpack_public_path__ + "static/img/s134.50358935.png";